import { useState, useEffect } from 'react';

/**
 * Hook to manage impersonation state and detect impersonated sessions
 */
export const useImpersonation = () => {
  const [impersonationData, setImpersonationData] = useState(null);

  useEffect(() => {
    // Decode JWT from localStorage to check for impersonation flag
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const parts = token.split('.');
        if (parts.length === 3) {
          const decoded = JSON.parse(atob(parts[1]));
          if (decoded.impersonatedBy && decoded.impersonatedAt) {
            setImpersonationData({
              impersonatedBy: decoded.impersonatedBy,
              impersonatedAt: decoded.impersonatedAt,
              currentUser: {
                id: decoded.id,
                name: decoded.name,
                email: decoded.email,
                role: decoded.role,
              },
            });
          } else {
            setImpersonationData(null);
          }
        }
      } catch (e) {
        console.error('Failed to decode token:', e);
      }
    }
  }, []);

  const exitImpersonation = () => {
    // Remove the token and redirect to login
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return { impersonationData, exitImpersonation };
};
